import React, { useState } from 'react';
import { DRAMA_TRIANGLE_MARKERS } from '../../utils/textAnalysis';
import { DataManager } from '../../services/dataManager';
import Button from '../common/Button';

const DramaTriangleExperiment = ({ client, onSave, onBack }) => {
    const [selections, setSelections] = useState({});
    const [isSaving, setIsSaving] = useState(false);

    const toggleMarker = (id) => {
        setSelections(prev => ({ ...prev, [id]: !prev[id] }));
    };

    const handleSave = async () => {
        setIsSaving(true);
        try {
            const results = DRAMA_TRIANGLE_MARKERS.map(role => {
                const selectedCount = role.markers.filter(m => selections[m.id]).length;
                return {
                    id: role.id,
                    name: role.name,
                    percentage: Math.round((selectedCount / role.markers.length) * 100),
                    count: selectedCount
                };
            });

            await DataManager.saveAssessment(client.id, {
                type: 'drama_triangle',
                results,
                selections,
                timestamp: new Date().toISOString()
            });

            if (onSave) onSave();
        } catch (error) {
            console.error("Error saving Drama Triangle:", error);
            alert("Errore nel salvataggio");
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div className="bg-white p-8 rounded-[2rem] shadow-xl border border-rose-50 animate-fade-in">
            <div className="flex justify-between items-start mb-8 border-b border-rose-50 pb-6">
                <div className="flex items-center gap-4">
                    <img src="/logo.png" alt="Logo" className="h-10 object-contain" />
                    <div>
                        <h3 className="text-2xl font-black text-rose-950 tracking-tight">AwarenessTool <span className="text-rose-200 font-light">|</span> Triangolo Drammatico</h3>
                        <p className="text-xs font-black text-rose-400 uppercase tracking-widest mt-1 opacity-70">Dinamiche relazionali di Karpman</p>
                    </div>
                </div>
                <div className="bg-rose-50 text-rose-600 px-3 py-1 rounded-full text-[10px] font-black tracking-tighter uppercase">Rilevazione Pattern</div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {DRAMA_TRIANGLE_MARKERS.map(role => (
                    <div key={role.id} className={`p-6 rounded-3xl border-2 transition-all ${role.color === 'rose' ? 'bg-rose-50 border-rose-100' : role.color === 'indigo' ? 'bg-indigo-50 border-indigo-100' : 'bg-amber-50 border-amber-100'}`}>
                        <div className="flex items-center gap-3 mb-4">
                            <span className="text-2xl">{role.icon}</span>
                            <h4 className="font-black uppercase tracking-tight text-slate-800">{role.name}</h4>
                        </div>
                        <div className="space-y-2">
                            {role.markers.map(m => (
                                <button
                                    key={m.id}
                                    onClick={() => toggleMarker(m.id)}
                                    className={`w-full text-left p-3 rounded-xl text-[11px] font-bold transition-all border-2 ${selections[m.id] ? 'bg-white border-slate-800 text-slate-800 shadow-sm' : 'bg-white/50 border-transparent text-slate-500 hover:bg-white'}`}
                                >
                                    {m.label}
                                </button>
                            ))}
                        </div>
                    </div>
                ))}
            </div>

            <div className="mt-10 flex justify-end gap-3">
                <button onClick={onBack} className="px-6 py-2 text-slate-400 font-bold hover:text-slate-600 transition">Annulla</button>
                <Button onClick={handleSave} loading={isSaving} className="bg-rose-600 hover:bg-rose-700">Registra Analisi</Button>
            </div>
        </div>
    );
};

export default DramaTriangleExperiment;
